module.exports = __webpack_public_path__ + "static/media/potionBottle.964a7400.png";